import React, { useState, useRef } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  CommonErrorMsg,
  ErrorMsg,
  InfoIcon,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { baseURL, post } from "../../Util/axios_helper";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoEditor } from "../../Kendo/kendo_editor";
import { generateGuid } from "../../Kendo/kendo_common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import Constants from "../../Util/constant";
import { toast } from "react-toastify";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const Packages = () => {
  const [error, setError] = useState({});
  const [newFunctions, setNewFunctions] = useState([]);
  const [isAddIcon, setIsAddIcons] = useState(true);

  const [eventTitle, setEventTitle] = useState("");
  const [eventTypeId, setEventTypeId] = useState(null);
  const [title, setTitle] = useState("");
  const modalRef = useRef(null);
  const [refreshflag, setrefreshflag] = useState(0);
  const [PackagesList, setPackagesList] = useState([]);
  const [packageCount, setPackagesCount] = useState(0);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [Loading, setLoading] = useState(false);

  const [Packages, SetPackages] = useState({
    PackagesID: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    PackageName: "",
    Amount: 0,
    PackagesPoints: "",
    Button1Name: "",
    Button1Link: "",
    Button2Name: "",
    Button2Link: "",
    SortOrder: 0,
    SavedBy: 0,
  });
  const [UpdatePackages, SetUpdatePackages] = useState({
    PackagesID: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    PackageName: "",
    Amount: 0,
    PackagesPoints: "",
    Button1Name: "",
    Button1Link: "",
    Button2Name: "",
    Button2Link: "",
    // SortOrder: 0,
    // SavedBy: 0,
  });

  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },

    {
      field: "eventName",
      title: "Displayed In",
    },
  ];
  const childColumn = [
    { field: "packagesID", hidden: true },
    {
      field: "displayedInID",
      hidden: true,
    },
    { field: "sortOrder", hidden: true },

    {
      field: "displayedInName",
      hidden: true,
    },
    { field: "packageName", title: "Package Name" },
    { field: "amount", title: "Amount" },
    {
      field: "packagesPoints",
      title: "List",
      // Render function to strip HTML tags and truncate the text
      template: (dataItem) => {
        const strippedText = stripHtmlTags(dataItem.packagesPoints);
        return strippedText.length > 50
          ? strippedText.substring(0, 50) + "..."
          : strippedText;
      },
    },
    { field: "button1Name", hidden: true },
    { field: "button1Link", hidden: true },
    { field: "button2Name", hidden: true },
    { field: "button2Link", hidden: true },
  ];

  const stripHtmlTags = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };
  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setDescFlag(false);
    SetPackages({
      PackagesID: 0,
      DisplayedInID: 0,
      DisplayedInName: "",
      packageName: "",
      amount: 0,
      PackagesPoints: "",
      Button1Name: "",
      Button1Link: "",
      Button2Name: "",
      Button2Link: "",
      // SortOrder: 0,
      // SavedBy: 0,
    });
    setError({});
    setPackagesList([]);
    setIsAddIcons(true);
    setPackagesCount();
    setIsAddIcons(true);

    setIsButtonVisible(true);

    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const onValidation = (name, val) => {
    setError((prevErr) => ({
      ...prevErr,
      [name]: !val || val.trim() === "",
    }));
  };

  const onValidationURL = (name, val) => {
    // URL validation regex pattern
    const urlPattern =
      /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9]{2,6}(\/[a-z0-9-._~:?#%&=]*)?$/i;

    if (urlPattern.test(val.trim())) {
      setError((prvErr) => {
        return {
          ...prvErr,
          [name]: false,
        };
      });
    } else {
      setError((prvErr) => {
        return {
          ...prvErr,
          [name]: true,
        };
      });
    }
  };

  const handlePackageEditClick = (e) => {
    setTitle(e.child.displayedInName);
    SetUpdatePackages({
      DisplayedInID: e.parent.displayedInID,
      PackagesID: e.child.packagesID,
      DisplayedInName: e.child.displayedInName,
      PackageName: e.child.packageName,
      Amount: e.child.amount,
      PackagesPoints: e.child.packagesPoints,
      Button1Name: e.child.button1Name,
      Button2Name: e.child.button2Name,
      Button1Link: e.child.button1Link,
      Button2Link: e.child.button2Link,
    });
    setIsAddIcons(false);
    $("#update_Packages").modal("show");
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `Packages/DeletePackage?packageId=${e.packagesID}`,
        true,
        false,
        true
      );
      refreshChildGrd();

      setrefreshflag(refreshflag + 1);
    };
    confirmDelete(onDelete);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (PackagesList.length === 0) {
      setError({ EmptyList: true });
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        PackagesList.forEach((packages, index) => {
          formData.append(
            `packagesModel[${index}].PackagesID`,
            packages.PackagesID
          );
          formData.append(
            `packagesModel[${index}].DisplayedInID`,
            packages.DisplayedInID || ""
          );
          formData.append(
            `packagesModel[${index}].PackageName`,
            packages.PackageName || ""
          );
          formData.append(
            `packagesModel[${index}].PackagesPoints`,
            packages.PackagesPoints || ""
          );
          formData.append(
            `packagesModel[${index}].Amount`,
            packages.Amount || ""
          );
          formData.append(
            `packagesModel[${index}].Button1Name`,
            packages.Button1Name || ""
          );
          formData.append(
            `packagesModel[${index}].Button2Name`,
            packages.Button2Name || ""
          );
          formData.append(
            `packagesModel[${index}].Button1Link`,
            packages.Button1Link || ""
          );
          formData.append(
            `packagesModel[${index}].Button2Link`,
            packages.Button2Link || ""
          );
        });
        await corepost("Packages/InsertUpdatePackages", formData);

        $("#add_Packages").modal("hide");
        clearForm();
        refreshChildGrd();
        setrefreshflag(refreshflag + 1);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onEditClick = async (e) => {
    let data = await corefetch(
      `Packages/GetPackagesCount?displayedInId=${e.displayedInID}`
    );

    if (data && data.packageCount !== undefined) {
      const packageCount = data.packageCount;
      setPackagesCount(packageCount);

      if (packageCount >= 3) {
        toast.error("Packages limit of 3 has been exceeded.");
      } else {
        const eventName = e.eventName;
        setTitle(eventName);

        SetPackages((prevBlog) => ({
          ...prevBlog,
          DisplayedInID: e.displayedInID,
        }));

        $("#add_Packages").modal("show");
      }
    } else {
      console.error("Failed to fetch package count or invalid response");
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-PackagesTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };
  const onRowReorderChange = async (List) => {
    try {
      let PackagesID = $(List.newRow).find("td").eq(0).text();
      let displayedInId = $(List.newRow).find("td").eq(1).text();
      let oldSortId = $(List.newRow).find("td").eq(2).text();
      let newSortId = $(List.oldRow).find("td").eq(2).text();
      await corefetch(
        `Packages/SortPackage?TypeId=${PackagesID}&newSortId=${newSortId}&oldSortId=${oldSortId}&displayedInId=${displayedInId}`
      );
      refreshChildGrd();
      setrefreshflag(refreshflag + 1);
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };
  const [DescFlag, setDescFlag] = useState(false);

  const handleEditorChange = (e) => {
    const newValue = e;

    const strippedValue = newValue
      .replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
      .replace(/&nbsp;/g, " ") // Replace non-breaking spaces with regular spaces
      .trim();

    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);

    if (sanitizedValue) {
      setDescFlag(true);
      setError((prev) => ({ ...prev, PackagesPoints: true }));
    } else {
      setDescFlag(false);
      setError((prev) => ({ ...prev, PackagesPoints: false }));
      SetPackages((prevEvents) => ({
        ...prevEvents,
        PackagesPoints: newValue,
      }));
    }
  };

  const handleUpdateEditorChange = (e) => {
    const newValue = e;
    const strippedValue = newValue
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);
    if (sanitizedValue) {
      setDescFlag(true);
      setError((prev) => ({ ...prev, PackagesPoints: true }));
    } else {
      setDescFlag(false);
      setError((prev) => ({ ...prev, PackagesPoints: false }));
      SetUpdatePackages((prevEvents) => ({
        ...prevEvents,
        PackagesPoints: newValue,
      }));
    }

    // onValidation("PackagesPoints", sanitizedValue);
  };

  const OnPackagesAdd = (e) => {
    e.preventDefault();

    const urlPattern =
      /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9]{2,6}(\/[a-z0-9-._~:?#%&=]*)?$/i;
    let urlInvalid = false;

    if (
      !urlPattern.test(Packages.Button1Link.trim()) ||
      !urlPattern.test(Packages.Button2Link.trim())
    ) {
      urlInvalid = true;
    }

    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      // const sanitizedPoints = Packages.PackagesPoints.replace(
      //   /&nbsp;/g,
      //   ""
      // ).trim();

      // If sanitized PackagesPoints is empty or invalid, prevent form submission
      if (!urlInvalid && !DescFlag) {
        setError((prev) => ({ ...prev, PackagesPoints: false }));
        setError({ EmptyList: false });

        // Create a new package object with a unique GUID
        let temp = { ...Packages, guid: generateGuid() };

        // Add the new package to the packages list
        SetPackages(temp);
        setPackagesList([...PackagesList, Packages]);

        // Reset form fields
        SetPackages((prev) => ({
          ...prev,
          PackageName: "",
          Amount: 0,
          PackagesPoints: "",
          Button1Name: "",
          Button1Link: "",
          Button2Name: "",
          Button2Link: "",
        }));

        // Clear file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = null;
        }

        // Check button visibility based on the total package count
        const totalCount = packageCount + PackagesList.length + 1;
        if (totalCount >= 3) {
          setIsButtonVisible(false);
          return;
        }
        setIsButtonVisible(true);
      }
      // else {
      //   // If PackagesPoints is empty or invalid, set an error
      //   setError((prev) => ({ ...prev, PackagesPoints: true }));
      // }
    }
  };

  const handlePackageAddDeleteClick = (e) => {
    const index = PackagesList.findIndex((item) => item.guid == e.guid);

    if (index !== -1) {
      const temp = PackagesList.filter((_, i) => i != index);
      setPackagesList(temp);
      setIsButtonVisible(temp.length < 3);
    }
  };
  const onUpdate = async (e) => {
    e.preventDefault();

    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!DescFlag) {
      setError((prev) => ({ ...prev, PackagesPoints: false }));
      setError({ EmptyList: false });
      // if (sanitizedPoints !== "") {
      //   setError((prev) => ({ ...prev, PackagesPoints: false }));
      //   setError({ EmptyList: false });

      {
        try {
          setLoading(true);
          const formData = new FormData();
          const packages = [UpdatePackages];

          packages.forEach((packages, index) => {
            formData.append(
              `packagesModel[${index}].PackagesID`,
              packages.PackagesID
            );
            formData.append(
              `packagesModel[${index}].DisplayedInID`,
              packages.DisplayedInID || ""
            );
            formData.append(
              `packagesModel[${index}].PackageName`,
              packages.PackageName || ""
            );
            formData.append(
              `packagesModel[${index}].PackagesPoints`,
              packages.PackagesPoints || ""
            );
            formData.append(
              `packagesModel[${index}].Amount`,
              packages.Amount || ""
            );
            formData.append(
              `packagesModel[${index}].Button1Name`,
              packages.Button1Name || ""
            );
            formData.append(
              `packagesModel[${index}].Button2Name`,
              packages.Button2Name || ""
            );
            formData.append(
              `packagesModel[${index}].Button1Link`,
              packages.Button1Link || ""
            );
            formData.append(
              `packagesModel[${index}].Button2Link`,
              packages.Button2Link || ""
            );
          });
          await corepost("Packages/InsertUpdatePackages", formData);

          $("#update_Packages").modal("hide");
          clearForm();
          refreshChildGrd();
          // setrefreshflag(refreshflag + 1);
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Packages</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">Packages</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-auto ms-auto">
        <KendoTreeTable
          name={"PackagesTreetable"}
          parentTableColumns={Parentscolumns}
          // parentTableData={hardcodedEventTypes}
          parentTableUrl={CorebaseURL + "Packages/GetDisplayesInList"}
          childTableUrl={
            CorebaseURL +
            "Packages/GetPackagesDetailsById?displayedinID={displayedInID}"
          }
          childTableColumns={childColumn}
          onParentEditClick={onEditClick}
          showParentOptions={true}
          showParentDelete={false}
          showChildOptions={true}
          showChildDelete={true}
          onChildEditClick={handlePackageEditClick}
          onChildDeleteClick={handleDeleteClick}
          refreshWhen={PackagesList.length}
          enableRowReorderable={true}
          onRowReorder={onRowReorderChange}
          noteLabel="Note:"
          noteContent="This module supports drag-and-drop functionality, you can easily
                  rearrange or move data as needed."
          // refreshWhen={refreshflag}
        />

        {/* Add Function Modal */}
        <div
          className="modal custom-modal fade"
          id="add_Packages"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered packages"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title}-Add</h5>

                {/* Close Button (X) */}
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>

                {/* Plus Button below the X */}
              </div>

              <div className="modal-body">
                {/* Form to add event details */}
                <form id="event-form" onSubmit={OnPackagesAdd}>
                  <input
                    type="hidden"
                    name="packagesID"
                    value={Packages.PackagesID || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={Packages.DisplayedInID || 0}
                  />
                  <div className="row align-items-end">
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Package Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Package Name with a maximum length of 25 characters." />
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={25}
                        name="PackageName"
                        value={Packages.PackageName || ""}
                        placeholder="Package Name"
                        data-required="true"
                        onChange={(e) => {
                          SetPackages((prev) => ({
                            ...prev,
                            PackageName: e.target.value,
                          }));
                          onValidation("PackageName", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Package Name is required"
                        IsError={error.PackageName}
                      />
                      {/* {error.PackageName && (
                        <ErrorMsg text="Package Name is required" />
                      )} */}
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        maxLength={10}
                        className="form-control"
                        name="Amount"
                        value={Packages.Amount || ""}
                        placeholder="Amount in dollars"
                        data-required="true"
                        onChange={(e) => {
                          const regex = /^[0-9]{0,10}(\.[0-9]{0,2})?$/;

                          if (regex.test(e.target.value)) {
                            SetPackages((prev) => ({
                              ...prev,
                              Amount: e.target.value,
                            }));
                            onValidation("Amount", e.target.value);
                          }
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                      />
                      <CommonErrorMsg
                        text="Amount is required"
                        IsError={error.Amount}
                      />
                      {/* {error.Amount && <ErrorMsg text="Amount is required" />} */}
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        List <span className="text-danger">*</span>
                      </label>
                      <KendoEditor
                        name="PackagesPoints"
                        imageBrowser={{
                          enable: true,
                          read: baseURL + "EmailTemplate/GetImages",
                          upload: baseURL + "EmailTemplate/UploadImage",
                          delete: baseURL + "EmailTemplate/DeleteImage",
                          image: baseURL + "EmailTemplate/GetImage?path={0}",
                          thumbnail: baseURL + "EmailTemplate/GetThumbnail",
                        }}
                        height={"340px"}
                        required={true}
                        // onValidate={onValidation}
                        value={Packages.PackagesPoints || ""}
                        onChange={handleEditorChange}
                        insertImage={false}
                        createLink={false}
                        unlink={false}
                      />
                      <CommonErrorMsg
                        text="List is required"
                        IsError={error.PackagesPoints}
                      />
                      {/* {error.PackagesPoints && (
                        <ErrorMsg text="Points is required" />
                      )} */}
                    </div>

                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Button 1 Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Button 1 Name  with a maximum length of 20 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        name="Button1Name"
                        value={Packages.Button1Name}
                        placeholder="Button Name"
                        data-required="true"
                        onChange={(e) => {
                          SetPackages((prev) => ({
                            ...prev,
                            Button1Name: e.target.value,
                          }));
                          onValidation("Button1Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Button 1 Name is required"
                        IsError={error.Button1Name}
                      />
                      {/* {error.Button1Name && (
                        <ErrorMsg text="Button Name is required" />
                      )} */}
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Button 1 Link <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Button1Link"
                        value={Packages.Button1Link}
                        placeholder="Button Link"
                        data-required="true"
                        onChange={(e) => {
                          SetPackages((prev) => ({
                            ...prev,
                            Button1Link: e.target.value,
                          }));
                          onValidation("Button1Link", e.target.value);
                          onValidationURL("btn1Invalid", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text={
                          error.Button1Link
                            ? "Button 1 Link is required"
                            : "Please enter a valid URL for Button 1 Link"
                        }
                        IsError={error.Button1Link || error.btn1Invalid}
                      />
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Button 2 Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Button 2 Name  with a maximum length of 20 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        name="Button2Name"
                        value={Packages.Button2Name}
                        placeholder="Button Name"
                        data-required="true"
                        onChange={(e) => {
                          SetPackages((prev) => ({
                            ...prev,
                            Button2Name: e.target.value,
                          }));
                          onValidation("Button2Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Button 2 Name is required"
                        IsError={error.Button2Name}
                      />
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Button 2 Link <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Button2Link"
                        value={Packages.Button2Link}
                        placeholder="Button Link"
                        data-required="true"
                        onChange={(e) => {
                          SetPackages((prev) => ({
                            ...prev,
                            Button2Link: e.target.value,
                          }));
                          onValidation("Button2Link", e.target.value);
                          onValidationURL("btn2Invalid", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text={
                          error.Button2Link
                            ? "Button 2 Link is required"
                            : "Please enter a valid URL for Button 2 Link"
                        }
                        IsError={error.Button2Link || error.btn2Invalid}
                      />
                    </div>
                    <div className="col-md-2 mb-3">
                      {isButtonVisible && (
                        <button
                          type="submit"
                          className="btn btn-primary mt-2"
                          title="Add Function"
                          style={{ marginBottom: "25px" }}
                        >
                          <i
                            className={
                              isAddIcon
                                ? "las la-plus-circle"
                                : "las la-check-circle"
                            }
                          ></i>
                        </button>
                      )}
                    </div>
                    <CommonErrorMsg
                      text={"Please add at least one package"}
                      IsError={error.EmptyList}
                    />
                  </div>
                </form>

                <form id="subgrid-form" onSubmit={onSubmit}>
                  <span className="k-form-error k-invalid-msg">
                    (Note: Only the items added to the grid will be saved.)
                  </span>
                  <KendoGrid
                    name={"packagesSubGrid"}
                    disableToolbar={true}
                    paggable={false}
                    data={PackagesList}
                    columns={[
                      {
                        field: "guid",
                        hidden: true,
                      },
                      {
                        field: "PackagesID",
                        hidden: true,
                      },
                      {
                        field: "DisplayedInID",
                        hidden: true,
                      },
                      {
                        field: "Button1Name",
                        hidden: true,
                      },
                      {
                        field: "Button1Link",
                        hidden: true,
                      },
                      {
                        field: "Button2Name",
                        hidden: true,
                      },
                      {
                        field: "Button2Link",
                        hidden: true,
                      },
                      // {
                      //   field: "displayedInName",
                      //   title: "DisplayedIn"
                      // },
                      {
                        field: "PackageName",
                        title: "Package Name",
                      },
                      {
                        field: "Amount",
                        title: "Amount",
                      },
                      {
                        field: "PackagesPoints",
                        hidden: true,
                      },
                    ]}
                    showOptions={true}
                    showDelete={true}
                    showEdit={false}
                    onDeleteClick={(e) => handlePackageAddDeleteClick(e)}
                    refreshWhen={PackagesList.length}
                  />
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="packages-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={"Save"} />
                    </div>
                  )}
                  <button
                    type="button"
                    id="hide"
                    style={{ display: "none" }}
                    data-bs-dismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  ></button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* update */}

        <div
          className="modal custom-modal fade"
          id="update_Packages"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered packages"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title}-Edit</h5>

                {/* Close Button (X) */}
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>

                {/* Plus Button below the X */}
              </div>

              <div className="modal-body">
                {/* Form to add event details */}
                <form id="update-form" onSubmit={onUpdate}>
                  <input
                    type="hidden"
                    name="packagesID"
                    value={UpdatePackages.PackagesID || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={UpdatePackages.DisplayedInID || 0}
                  />
                  <div className="row align-items-end">
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Package Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Package Name with a maximum length of 25 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={25}
                        className="form-control"
                        name="PackageName"
                        value={UpdatePackages.PackageName || ""}
                        placeholder="Package Name"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            PackageName: e.target.value,
                          }));
                          onValidation("PackageName", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Package Name is required"
                        IsError={error.PackageName}
                      />
                      {/* {error.PackageName && (
                        <ErrorMsg text="Package Name is required" />
                      )} */}
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Amount"
                        value={UpdatePackages.Amount || ""}
                        placeholder="Amount in dollars"
                        data-required="true"
                        onChange={(e) => {
                          const regex = /^[0-9]{0,10}(\.[0-9]{0,2})?$/;
                          if (regex.test(e.target.value)) {
                            SetUpdatePackages((prev) => ({
                              ...prev,
                              Amount: e.target.value,
                            }));
                            onValidation("Amount", e.target.value);
                          }
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                      />
                      <CommonErrorMsg
                        text="Amount is required"
                        IsError={error.Amount}
                      />
                      {/* {error.Amount && <ErrorMsg text="Amount is required" />} */}
                    </div>
                    {/* <div className="col-md-5 mb-3">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="Amount"
                        value={UpdatePackages.Amount}
                        placeholder="Amount in dollars"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            Amount: e.target.value,
                          }));
                          onValidation("Amount", e.target.value);
                        }}
                      />
                      {error.Amount && <ErrorMsg text="Amount is required" />}
                    </div> */}

                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        List <span className="text-danger">*</span>
                      </label>
                      <KendoEditor
                        name="PackagesPoints"
                        required={true}
                        onValidate={onValidation}
                        value={UpdatePackages.PackagesPoints || ""}
                        onChange={handleUpdateEditorChange}
                        insertImage={false}
                        createLink={false}
                        unlink={false}
                      />
                      <CommonErrorMsg
                        text="List is required"
                        IsError={error.PackagesPoints}
                      />
                      {/* {error.PackagesPoints && (
                        <ErrorMsg text="Points is required" />
                      )} */}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Button 1 Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Button 1 Name  with a maximum length of 20 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        name="Button1Name"
                        value={UpdatePackages.Button1Name}
                        placeholder="List"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            Button1Name: e.target.value,
                          }));
                          onValidation("Button1Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Button 1 Name is required"
                        IsError={error.Button1Name}
                      />
                      {/* {error.Button1Name && (
                        <ErrorMsg text="Button Name is required" />
                      )} */}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Button 1 Link <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Button1Link"
                        value={UpdatePackages.Button1Link}
                        placeholder="List"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            Button1Link: e.target.value,
                          }));
                          onValidation("Button1Link", e.target.value);
                          onValidationURL("btn1Invalid", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text={
                          error.Button1Link
                            ? "Button 1 Link is required"
                            : "Please enter a valid URL for Button 1 Link"
                        }
                        IsError={error.Button1Link || error.btn1Invalid}
                      />
                      {/* {error.Button1Link === "required" && (
                        <ErrorMsg text="Button Link is required" />
                      )}{" "}
                      {error.Button1Link === "invalidUrl" && (
                        <ErrorMsg text="Please enter a valid URL for Button 1 Link" />
                      )} */}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Button 2 Name <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Button 2 Name  with a maximum length of 20 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        name="Button2Name"
                        value={UpdatePackages.Button2Name}
                        placeholder="List"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            Button2Name: e.target.value,
                          }));
                          onValidation("Button2Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Button 2 Name is required"
                        IsError={error.Button2Name}
                      />
                      {/* {error.Button2Name && (
                        <ErrorMsg text="Button Name is required" />
                      )} */}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Button 2 Link <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Button2Link"
                        value={UpdatePackages.Button2Link}
                        placeholder="List"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdatePackages((prev) => ({
                            ...prev,
                            Button2Link: e.target.value,
                          }));
                          onValidation("Button2Link", e.target.value);
                          onValidationURL("btn2Invalid", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text={
                          error.Button2Link
                            ? "Button 2 Link is required"
                            : "Please enter a valid URL for Button 2 Link"
                        }
                        IsError={error.Button2Link || error.btn2Invalid}
                      />
                      {/* {error.Button1Link === "required" && (
                        <ErrorMsg text="Button Link is required" />
                      )}{" "}
                      {error.Button1Link === "invalidUrl" && (
                        <ErrorMsg text="Please enter a valid URL for Button 2 Link" />
                      )} */}
                    </div>
                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="packages-cancel"
                          dataBsDismiss={"modal"}
                          onClick={() => {
                            clearForm();
                          }}
                        />
                        <Button name={"Update"} />
                      </div>
                    )}
                    <button
                      type="button"
                      id="hide"
                      style={{ display: "none" }}
                      data-bs-dismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    ></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
